




























import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import {
    SaveGoodClinicalPracticeMedicine
} from "@/api/hd";
import util from "@/lib/util";

@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  form: any = {};
  created() {
    console.log(this.data);
    if (this.data.title == "编辑") {
      this.form = Object.assign({}, this.data.row);
      this.form.medicineDate = this.formatDateTime(this.form.medicineDate)
      this.form.nextMedicineDate = this.formatDateTime( this.form.nextMedicineDate)
    }else{
      this.form.medicineDate = new Date();
      this.form.nextMedicineDate = new Date();
    }
  }
  rules = {
  };
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.form.gcptId = this.data.info.id;
        this.form.medicineDate = this.formatDateTime( this.form.medicineDate)
        this.form.nextMedicineDate = this.formatDateTime( this.form.nextMedicineDate)
        let res = await SaveGoodClinicalPracticeMedicine(this.form);
        if (res.status == 1) {
          this.$emit("input", false);
          this.$emit("on-success");
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/gcpManage/parts/gcpPractice/medicine.vue